<script lang="ts" setup>
import CreateCheckCallForm from "@/views/trips/components/forms/CreateCheckCallForm.vue";
import type { CheckCallDTO, CreateCheckCallRequest } from "@/api/trips/dto/check-call";
import type { CheckCallFormProps } from "@/types/props";

const props = defineProps<CheckCallFormProps>();

const emits = defineEmits<{
  (e: "success", checkCall: CheckCallDTO): void;
  (e: "create", checkCall: CreateCheckCallRequest): void;
  (e: "close"): void;
  (e: "edit"): void;
}>();
</script>

<template>
  <create-check-call-form
    :check-call-preview="props.checkCallPreview"
    :creation-loading="props.creationLoading"
    :orders="props.orders"
    :route-id="props.routeId"
    :route-stops="props.routeStops"
    :title="title"
    :trip-id="props.tripId"
    :truck-id="truckId"
    :truck-number="truckNumber"
    is-dispatch-confirmation
    @close="emits('close')"
    @create="emits('create', $event)"
    @edit="emits('edit')"
    @success="emits('success', $event)"
  >
    <template #subtitle>
      <div class="d-flex align-center mb-4">
        <span class="text-grey-darken-1"> You are about to confirm dispatch for</span>

        <router-link
          v-if="props.truckId"
          :to="{ name: 'truck-view', params: { id: props.truckId } }"
          class="text-primary text-decoration-none ml-1"
          data-qa="modal-truck-number"
          target="_blank"
        >
          Truck #{{ props.truckNumber }}
        </router-link>
      </div>
    </template>
  </create-check-call-form>
</template>

<style lang="scss" scoped></style>
